/** @format */

import { Toggle, ToggleProps } from "@ui-library/core/lib/molecules"
import React, { useState } from "react"

const ToggleWithState = (props: ToggleProps) => {
	const [checked, setChecked] = useState<boolean>(props.checked)
	const onChange = (value: boolean) => {
		setChecked(value)
		props.onChange(value)
	}
	const newProps = { ...props, onChange, checked }
	return <Toggle {...newProps} />
}

export default ToggleWithState